var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPortfolioOffensiveAggressive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8585_749)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 112.5,
    r: 112.5,
    fill: "#80E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 0C140.809 3.3758e-07 168.077 10.6726 188.865 29.8887C209.653 49.1048 222.432 75.4517 224.653 103.673C226.874 131.895 218.374 159.917 200.848 182.148C183.322 204.38 158.059 219.186 130.099 223.615C102.138 228.043 73.5363 221.768 49.9983 206.04C26.4603 190.313 9.71694 166.289 3.10837 138.763C-3.5002 111.236 0.511881 82.2295 14.3442 57.5301C28.1766 32.8307 50.8123 14.254 77.7356 5.50612L112.5 112.5L112.5 0Z",
    fill: "#1D873E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8585_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolioOffensiveAggressive);
export default __webpack_public_path__ + "static/media/icon--portfolio--offensive-aggressive.ecbc680d8bf6e35d34c4a8dfae5d4c00.svg";
export { ForwardRef as ReactComponent };